import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlood = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M27.3037 12.3166C28.7041 12.0332 30.1044 11.9407 31.5049 12.0383C31.8276 13.3053 32 14.6327 32 16.0002C31.9999 24.8367 24.8365 32.0002 16 32.0002C7.16351 32.0002 0.000114426 24.8367 0 16.0002C0 14.6405 0.170036 13.3203 0.489258 12.0598C1.98698 11.9271 3.4847 12.0135 4.98242 12.3166L5.875 12.51C7.95832 12.9316 10.0417 12.9316 12.125 12.51L13.0176 12.3166C15.2497 11.8648 17.4817 11.8971 19.7139 12.4133C21.9461 12.9296 24.1789 12.9618 26.4111 12.51L27.3037 12.3166Z",
			fill: "#1257DD"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .75,
			d: "M26.8574 17.8474C28.5574 17.0404 30.257 16.8124 31.957 17.158C31.3637 25.4539 24.4471 31.9998 16 31.9998C7.57307 31.9998 0.667998 25.4853 0.0458984 17.2175C1.84007 16.7855 3.63454 16.9956 5.42871 17.8474C7.80966 18.9778 10.1903 18.9778 12.5713 17.8474C14.9521 16.7171 17.3331 16.7172 19.7139 17.8474C22.0948 18.9778 24.4765 18.9778 26.8574 17.8474Z",
			fill: "#1257DD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5713 24.283C14.9522 22.5729 17.3329 22.5729 19.7139 24.283C22.0948 25.9932 24.4765 25.9931 26.8574 24.283C28.0349 23.4373 29.2121 23.009 30.3896 22.9998C27.7929 28.328 22.326 31.9998 16 31.9998C9.67617 31.9998 4.21009 28.3308 1.6123 23.0057C2.88439 22.943 4.15663 23.3693 5.42871 24.283C7.80947 25.9929 10.1905 25.9929 12.5713 24.283Z",
			fill: "#1257DD"
		})
	]
});
export default SvgFlood;
